import React, { useMemo } from 'react';
import { Grid, TextField } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import cn from 'classnames';
import AudioPicker from '@dyl/components/AudioPicker';
import { useAudio } from '@dyl/systems/AudiosManager';

const useStyles = makeStyles(theme => ({
    root: {
        maxWidth: theme.breakpoints.values.md * 3 / 4,
    },
    audioContainer: {},
    audio: {},
    transcriptContainer: {},
    transcript: {},
}));

/**
 * @param {Object} props
 * @param {Parameters<AudioPicker>[0]['value']} props.value
 * @param {Parameters<AudioPicker>[0]['onChange']} props.onChange
 * @param {string} props.label
 * @param {string} [props.id]
 * @param {string} [props.error]
 * @param {boolean} [props.allowEmpty]
 */
export default function AudioAndTranscriptBlock({
    value,
    onChange,
    label,
    id,
    className: propsClass,
    error,
    allowEmpty,
    helperText = 'Must be .mp3',
    required = false,
    ...other
}) {
    const classes = useStyles();
    const labelPrefix = useMemo(() => {
        const [, labelPrefix = label] = /^(.*)(?:\s*audio\s*)$/i.exec(label) ?? [];

        return labelPrefix;
    }, [label]);

    const { transcript } = useAudio(value) ?? {};

    return (
        <Grid container spacing={3} className={cn(classes.root, propsClass)} {...other}>
            <Grid item xs={12} sm={6} className={classes.audioContainer}>
                <AudioPicker
                    className={classes.audio}
                    id={id}
                    value={value}
                    onChange={onChange}
                    label={`${labelPrefix} Audio`}
                    helperText={error ?? helperText}
                    fullWidth
                    error={!!error}
                    allowEmpty={allowEmpty}
                    required={required}
                />
            </Grid>

            <Grid item xs={12} sm={6} className={classes.transcriptContainer}>
                <TextField
                    className={classes.transcript}
                    id={id && `${id}-transcript`}
                    fullWidth
                    label={`${labelPrefix} Transcript`}
                    disabled
                    variant='filled'
                    multiline
                    value={transcript || 'No transcript assigned'}
                />
            </Grid>
        </Grid>
    );
}